(function () {
  'use strict';

  function money(paise) {
    return '\u20B9' + (Math.round(paise) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 0 });
  }

  function init(root) {
    if (!root || root.dataset.upkBqtInit === '1') return;
    root.dataset.upkBqtInit = '1';

    var chargeVariant = parseInt(root.dataset.chargeVariant, 10);
    var chargeAmount = (parseInt(root.dataset.chargeAmount, 10) || 300) * 100;
    var minItems = parseInt(root.dataset.minItems, 10) || 2;
    var pct = parseInt(root.dataset.discountPct, 10); if (isNaN(pct) || pct < 0) pct = 0;

    var categories = [];
    var catScript = root.querySelector('[data-upk-bqt-categories]');
    if (catScript) {
      try { categories = JSON.parse(catScript.textContent) || []; } catch (e) { categories = []; }
    }
    var requiredCatIds = categories.filter(function (c) { return c.required; }).map(function (c) { return c.id; });

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-upk-bqt-card]'));
    var sumList = root.querySelector('[data-upk-bqt-sumlist]');
    var elSub = root.querySelector('[data-upk-bqt-subtotal]');
    var elDisc = root.querySelector('[data-upk-bqt-discount]');
    var elChg = root.querySelector('[data-upk-bqt-chargeamt]');
    var elTot = root.querySelector('[data-upk-bqt-total]');
    var elNote = root.querySelector('[data-upk-bqt-note]');
    var elErr = root.querySelector('[data-upk-bqt-error]');
    var btn = root.querySelector('[data-upk-bqt-atc]');

    var mainImg = root.querySelector('[data-upk-bqt-mainimg]');
    if (mainImg) {
      root.querySelectorAll('[data-upk-bqt-thumb]').forEach(function (th, i) {
        if (i === 0) th.classList.add('is-active');
        th.addEventListener('click', function () {
          mainImg.src = th.dataset.full;
          root.querySelectorAll('[data-upk-bqt-thumb]').forEach(function (t) { t.classList.remove('active'); t.classList.remove('is-active'); });
          th.classList.add('is-active');
        });
      });
    }

    function variantOf(card) {
      var el = card.querySelector('[data-upk-bqt-variant]');
      if (!el) return null;
      if (el.tagName === 'SELECT') {
        var o = el.options[el.selectedIndex];
        if (!o) return null;
        return { id: parseInt(el.value, 10), price: parseInt(o.dataset.price, 10) || 0, label: o.text.replace(/, Sold out/, '').trim() };
      }
      return { id: parseInt(el.value, 10), price: parseInt(el.dataset.price, 10) || 0, label: '' };
    }

    function isDisc(card) { return card.dataset.disc !== '0'; }

    function titleOf(card) {
      var t = card.querySelector('.upk-bqt__title');
      return t ? t.textContent.trim() : '';
    }

    function selectedCards() {
      return cards.filter(function (c) { return c.classList.contains('is-selected'); });
    }

    function updateCategoryIndicators(satisfiedSet) {
      requiredCatIds.forEach(function (catId) {
        var indicator = root.querySelector('[data-upk-bqt-catreq="' + catId + '"]');
        if (!indicator) return;
        if (satisfiedSet[catId]) {
          indicator.textContent = '\u2713 Selected';
          indicator.classList.add('is-satisfied');
        } else {
          indicator.textContent = 'Required';
          indicator.classList.remove('is-satisfied');
        }
      });
    }

    function refresh() {
      var sel = selectedCards();
      var subtotal = 0, discBase = 0, discCount = 0;
      if (sumList) sumList.innerHTML = '';

      var satisfiedSet = {};
      sel.forEach(function (card) { satisfiedSet[card.dataset.category] = true; });
      updateCategoryIndicators(satisfiedSet);
      var allRequiredSatisfied = requiredCatIds.every(function (catId) { return satisfiedSet[catId]; });

      sel.forEach(function (card) {
        var v = variantOf(card);
        if (!v) return;
        subtotal += v.price;
        if (isDisc(card)) { discBase += v.price; discCount += 1; }
        if (sumList) {
          var li = document.createElement('li');
          var name = titleOf(card) + (v.label && v.label !== 'Default Title' ? ' \u2013 ' + v.label : '');
          var s1 = document.createElement('span'); s1.textContent = name;
          var s2 = document.createElement('span'); s2.textContent = money(v.price);
          li.appendChild(s1); li.appendChild(s2);
          sumList.appendChild(li);
        }
      });
      var discEligible = discCount >= minItems;
      var discount = discEligible ? Math.round(discBase * pct / 100) : 0;
      var total = subtotal - discount + (sel.length ? chargeAmount : 0);
      if (elSub) elSub.textContent = money(subtotal);
      if (elDisc) elDisc.textContent = '\u2212' + money(discount);
      if (elChg) elChg.textContent = sel.length ? money(chargeAmount) : money(0);
      if (elTot) elTot.textContent = money(sel.length ? total : 0);

      if (elNote) {
        if (!sel.length) {
          elNote.hidden = false;
          elNote.textContent = requiredCatIds.length
            ? 'Pick at least ' + minItems + ' pieces to build your hamper.'
            : 'Select at least ' + minItems + ' pieces to build your hamper.';
        } else if (!allRequiredSatisfied) {
          elNote.hidden = false;
          var missing = categories.filter(function (c) { return c.required && !satisfiedSet[c.id]; }).map(function (c) { return c.label; });
          elNote.textContent = 'Please select at least one from: ' + missing.join(', ') + '.';
        } else if (pct > 0 && !discEligible) {
          elNote.hidden = false;
          elNote.textContent = 'Add ' + (minItems - discCount) + ' more jewellery piece' + (minItems - discCount > 1 ? 's' : '') + (pct > 0 ? (' to unlock ' + pct + '% off.') : ' to build your hamper.');
        } else {
          elNote.hidden = true;
        }
      }

      if (btn) {
        var canAdd = requiredCatIds.length ? allRequiredSatisfied : sel.length > 0;
        btn.disabled = !canAdd;
        btn.textContent = canAdd ? 'Add hamper to cart, ' + money(total) : 'Add hamper to cart';
      }
      if (elErr) elErr.hidden = true;
    }

    cards.forEach(function (card) {
      var tick = card.querySelector('[data-upk-bqt-tick]');
      var wrap = card.querySelector('[data-upk-bqt-variantwrap]');
      var sel = card.querySelector('select[data-upk-bqt-variant]');
      if (tick) {
        tick.addEventListener('click', function () {
          var on = card.classList.toggle('is-selected');
          tick.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (wrap) wrap.hidden = !on;
          refresh();
        });
      }
      if (sel) {
        sel.addEventListener('change', function () {
          var o = sel.options[sel.selectedIndex];
          var priceEl = card.querySelector('[data-upk-bqt-price]');
          if (o && priceEl) priceEl.textContent = money(parseInt(o.dataset.price, 10) || 0);
          refresh();
        });
      }
    });

    function refreshCartDrawer() {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootUrl + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          if (s['cart-drawer']) {
            var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
            var src = doc.querySelector('cart-drawer');
            var dst = document.querySelector('cart-drawer');
            if (src && dst) dst.innerHTML = src.innerHTML;
          }
          if (s['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              var d2 = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
              var inner = d2.getElementById('cart-icon-bubble');
              bubble.innerHTML = inner ? inner.innerHTML : s['cart-icon-bubble'];
            }
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            drawer.classList.remove('is-empty');
            if (typeof drawer.open === 'function') drawer.open();
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'upk-bouquet' });
          }
        })
        .catch(function () {});
    }

    if (btn) {
      btn.addEventListener('click', function () {
        var sel = selectedCards();
        if (btn.disabled || !sel.length) return;

        var bundleId = 'BQ' + Date.now().toString(36).toUpperCase().slice(-6);
        var bundleName = root.querySelector('.upk-bqt__heading');
        bundleName = bundleName ? bundleName.textContent.trim() : 'Gift hamper';
        var bundleSize = sel.length + 1;

        var contains = [];
        var items = sel.map(function (card) {
          var v = variantOf(card);
          var name = titleOf(card) + (v.label && v.label !== 'Default Title' ? ' (' + v.label + ')' : '');
          contains.push(name);
          return {
            id: v.id,
            quantity: 1,
            properties: {
              '_upk_bundle_id': bundleId,
              '_upk_bundle_name': bundleName,
              '_upk_bundle_size': String(bundleSize)
            }
          };
        });
        items.push({
          id: chargeVariant,
          quantity: 1,
          properties: {
            '_upk_bundle_id': bundleId,
            '_upk_bundle_name': bundleName,
            '_upk_bundle_size': String(bundleSize),
            'Contains': contains.join(' \u2022 ')
          }
        });

        btn.classList.add('is-loading');
        var oldText = btn.textContent;
        btn.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'Could not add the hamper');
            return refreshCartDrawer();
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.textContent = 'Added \u2713';
            setTimeout(function () { refresh(); }, 1500);
          })
          .catch(function (err) {
            btn.classList.remove('is-loading');
            btn.textContent = oldText;
            if (elErr) { elErr.hidden = false; elErr.textContent = err.message || 'Something went wrong. Please try again.'; }
          });
      });
    }

    refresh();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-upk-bqt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
